import React, { useState } from 'react';

export default function StepTasks({ form, next, prev }) {
  const [done, setDone] = useState([]);

  const tasks = [
    { id: 1, title: 'FOLLOW @TheEidSheep', sub: 'Follow our official X account', url: 'https://x.com/intent/follow?screen_name=TheEidSheep_' },
    { id: 2, title: 'LIKE THE PINNED TWEET', sub: 'Show some love on our announcement', url: 'https://x.com/intent/like?tweet_id=2059373002631098666' },
    { id: 3, title: 'REPOST THE TWEET', sub: 'Spread the word to your timeline', url: 'https://x.com/intent/retweet?tweet_id=2059373002631098666' },
  ];

  const allDone = done.length === tasks.length;

  const handleClick = (id, url) => {
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
    if (!done.includes(id)) setDone(p => [...p, id]);
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '26px', letterSpacing: '1.5px', color: '#3D1F0A', textAlign: 'center', marginBottom: '4px' }}>
        COMPLETE THE TASKS
      </h2>
      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#6B4A1A', textAlign: 'center', marginBottom: '14px' }}>
        Every task is <strong style={{ color: '#C87400' }}>required</strong> to qualify for the whitelist.
      </p>

      {/* User badge */}
      <div style={{
        alignItems: 'center', gap: '6px',
        margin: '0 auto 14px', padding: '6px 14px',
        background: 'rgba(200,116,0,0.12)', borderRadius: '20px',
        border: '2px solid rgba(61,31,10,0.2)',
        fontFamily: "'Nunito', sans-serif", fontSize: '13px', fontWeight: '800',

        color: '#3D1F0A', display: 'flex inline-flex',
      }}>
        <span style={{ color: '#C87400', fontSize: '15px' }}>𝕏  </span>
        {form.x || '@user'}
      </div>

      {/* Disclaimer */}
      <div style={{
        background: 'rgba(61,31,10,0.06)', border: '2px dashed rgba(61,31,10,0.2)',
        borderRadius: '10px', padding: '8px 12px', marginBottom: '14px',
      }}>
        <p style={{ margin: 0, fontSize: '10px', color: '#6B4A1A', fontFamily: "'Nunito', sans-serif", lineHeight: '1.5' }}>
          ℹ Click each task to open it on X. Tasks are self-reported — entries that don't complete will be removed during manual review.
        </p>
      </div>

      {/* Task rows */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
        {tasks.map((task) => {
          const isDone = done.includes(task.id);
          return (
            <div
              key={task.id}
              className="wl-task-row"
              onClick={() => handleClick(task.id, task.url)}
              style={{
                display: 'flex', alignItems: 'center', padding: '10px 12px',
                background: isDone ? 'rgba(200,116,0,0.12)' : '#FFF9EE',
                borderRadius: '12px',
                border: isDone ? '2px solid rgba(200,116,0,0.4)' : '2px solid rgba(61,31,10,0.15)',
                cursor: 'pointer', transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(61,31,10,0.08)',
              }}
            >
              <div style={{
                width: '24px', height: '24px', borderRadius: '6px', flexShrink: 0,
                border: '2px solid #3D1F0A', marginRight: '10px',
                background: isDone ? 'linear-gradient(160deg, #C87400, #D4A017)' : 'transparent',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {isDone && <span style={{ color: '#F5EDD6', fontSize: '14px', fontWeight: '900' }}>✓</span>}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: "'Bangers', cursive", fontSize: '13px', letterSpacing: '0.5px', color: '#3D1F0A', marginBottom: '1px' }}>{task.title}</div>
                <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: '10px', color: '#8B6914' }}>{task.sub}</div>
              </div>
              <div style={{
                padding: '5px 10px', borderRadius: '8px', flexShrink: 0,
                border: '2px solid #3D1F0A',
                background: isDone ? 'linear-gradient(160deg, #C87400, #A85E00)' : 'rgba(61,31,10,0.06)',
                color: isDone ? '#F5EDD6' : '#3D1F0A',
                fontFamily: "'Bangers', cursive", fontSize: '11px', letterSpacing: '0.5px',
              }}>
                {isDone ? 'DONE ✓' : 'OPEN ↗'}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button className="wl-btn-back" onClick={prev} style={{
          flex: 1, padding: '13px',
          background: '#FFF9EE', border: '2px solid #3D1F0A', borderRadius: '10px',
          color: '#3D1F0A', fontFamily: "'Bangers', cursive", fontSize: '15px', letterSpacing: '1px',
          cursor: 'pointer', boxShadow: '0 4px 0 #7A4A00', transition: 'all 0.1s ease',
        }}>← BACK</button>
        <button className="wl-btn-primary" onClick={next} disabled={!allDone} style={{
          flex: 2, padding: '13px',
          background: allDone ? 'linear-gradient(160deg, #C87400, #A85E00)' : 'rgba(61,31,10,0.15)',
          border: '3px solid #3D1F0A', borderRadius: '10px',
          color: allDone ? '#F5EDD6' : '#8B6914',
          fontFamily: "'Bangers', cursive", fontSize: '17px', letterSpacing: '2px',
          cursor: allDone ? 'pointer' : 'not-allowed',
          transform: allDone ? 'skewX(-4deg)' : 'none',
          boxShadow: allDone ? '0 5px 0 #7A4A00' : 'none',
          opacity: allDone ? 1 : 0.55, transition: 'all 0.12s ease',
        }}>
          <span style={{ display: 'inline-block', transform: allDone ? 'skewX(4deg)' : 'none' }}>CONTINUE →</span>
        </button>
      </div>
    </div>
  );
}
